// DepartmentDropdown.js

import React, { useEffect, useState } from "react";
import { Form, Select } from 'antd';
import StorageListApi from "../../Apis/StorageListApi";

const StorageSelectHotHold = ({ valid }) => {
    const [Storages, setStorages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);

    const fetchStorages = async () => {
        try {
            setLoading(true);
            const response = await StorageListApi.ListStorage(page, 20);

            console.log('API Response:', response); // Debug log

            if (response && response.payloadDto) {
                setTotalPageNew(response.totalPages);

                // Fix the filter condition - try without filter first
                const filteredItems = response.payloadDto.filter(item =>
                    item && item.id && item.name // Basic validation
                    // Remove the sensorDTOList filter temporarily for debugging
                    // !item.sensorDTOList
                );

                console.log('Filtered items:', filteredItems); // Debug log

                setStorages(prevStorages => [
                    ...prevStorages,
                    ...filteredItems
                ]);
                setPage(prevPage => prevPage + 1);
            } else {
                console.warn('Unexpected API response structure:', response);
            }
        } catch (error) {
            console.error('Error fetching storage units:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleScroll = (e) => {
        const { scrollTop, clientHeight, scrollHeight } = e.target;
        const nearBottom = scrollHeight - scrollTop <= clientHeight + 50; // 50px buffer

        if (nearBottom && !loading) {
            if (TotalPageNew === null || page < TotalPageNew) {
                fetchStorages();
            }
        }
    };

    useEffect(() => {
        fetchStorages();
    }, []);

    // Debug: Check what's in Storages
    console.log('Current Storages state:', Storages);

    return (
        <>
            <Form.Item
                name="storageUnit"
                label="Storage Unit :"
                className={valid ? 'text-lable disabled' : 'text-lable'}
                rules={[
                    {
                        required: true,
                        message: "Please Select Storage Unit.",
                    },
                ]}
            >
                <Select
                    className="control-Select mb-1"
                    placeholder="Select Storage Unit"
                    disabled={valid}
                    onPopupScroll={handleScroll}
                    loading={loading}
                    showSearch
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    {Storages.length > 0 ? (
                        Storages
                            .filter(option => option.hot)
                            .map(option => (
                                <Select.Option key={option.id} value={option.id}>
                                    {option.name}
                                </Select.Option>
                            ))
                    ) : (
                        <Select.Option disabled value="no-data">
                            No storage units available
                        </Select.Option>
                    )}

                    {loading && (
                        <Select.Option disabled value="loading">
                            Loading...
                        </Select.Option>
                    )}
                </Select>
            </Form.Item>
        </>
    );
};

export default StorageSelectHotHold;